<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['系统通知', '系统通知详情']" />
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="12">
            <h2 class="notice-text">{{form.title}}</h2>
            <p class="notice-text">{{form.releaseTime}}</p>
            <div v-html="form.content"></div>
            <div class="info-footer">
              <el-button @click="back">返回</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'

export default {
  name: 'detail',
  data () {
    return {
      loading: true,
      id: '',
      typeName: '',
      form: {
        title: '',
        releaseTime: '',
        content: '',
        targetType: ''
      }
    }
  },
  components: {
    navHeader
  },
  methods: {
    getDetail (id) {
      this.$http
        .post('/notice/getById', {id})
        .then((res) => {
          if (res.data.code === '200') {
            this.form = res.data.data
            this.loading = false
          } else {
            this.$message.error(res.data.msg)
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
        })
    },
    back () {
      this.$router.push('systemNotice')
    }
  },
  created () {
    if (this.$route.params.id) {
      this.getDetail(this.$route.params.id)
    }
  }
}
</script>

<style scoped lang="less">
.notice-text {
  margin-bottom: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/systemNotice/detail.vue